import { Grid, Stack, styled } from '@mui/material';
import { useSpacerHeight } from 'features/navigation/ui/Navigation/Spacer';

interface AsideProps {
    sticky?: boolean;
}

export default function Aside({ sticky, children }: React.PropsWithChildren<AsideProps>) {
    return sticky
        ? <AsideSticky>{ children }</AsideSticky>
        : <AsideBase>{ children }</AsideBase>;
}

function AsideBase({ children }: React.PropsWithChildren) {
    return (
        <Grid size={ 1 }
            component="aside"
            display="grid"
        >
            <Stack spacing={ 3 }>
                { children }
            </Stack>
        </Grid>
    );
}

function AsideSticky({ children }: React.PropsWithChildren) {
    const spacerHeight = useSpacerHeight();

    return (
        <Grid size={ 1 }
            component="aside"
        >
            <StickyContainer top={ spacerHeight }>
                { children }
            </StickyContainer>
        </Grid>
    );
}

const StickyContainer = styled(Stack)(({ theme }) => ({
    position: 'sticky',
    paddingTop: theme.spacing(4),
    marginTop: theme.spacing(-4),
    gap: theme.spacing(3)
}));
